import React from "react";
import Settings from "../../components/settings/Settings";
import SettingsMenu from "../../components/settingMenu/SettingMenu";

const SettingsPage = () => {
  return (
    <SettingsMenu>
      <Settings />
    </SettingsMenu>
  );
};

export default SettingsPage;
